import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Avatar, Button, Dropdown, Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { atomUserInfo, collapsedSider } from 'recoil/atoms';
import { routes } from 'utils/common/routes';

const Header = () => {
  const navigate = useNavigate();
  const [isOpenSider, setIsOpenSider] = useRecoilState(collapsedSider);
  const dataUserInfo = useRecoilValue(atomUserInfo);

  const handleLogout = () => {
    navigate(routes.signout, { replace: true });
  };

  const items = [
    // {
    //   key: 'info',
    //   label: 'Thông tin cá nhân',
    //   icon: <UserOutlined />,
    //   onClick: () => navigate(routes.profile)
    // },
    {
      key: 'logout',
      label: 'Đăng xuất',
      icon: <LogoutOutlined />,
      danger: true,
      onClick: handleLogout
    }
  ];

  return (
    <Layout.Header
      className="h-12"
      style={{
        padding: '0px',
        backgroundColor: '#ffffff'
      }}
    >
      <div className="flex items-center justify-between pr-4">
        <Button
          className="!w-12 h-12"
          type="text"
          icon={isOpenSider ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setIsOpenSider(!isOpenSider)}
        />

        <Dropdown menu={{ items }} trigger={['click']}>
          <div className="flex items-center space-x-2 h-full cursor-pointer">
            <Avatar icon={<UserOutlined />} className="bg-primary" />
            <div className="flex flex-col">
              <span className="font-medium">{dataUserInfo?.username}</span>
              <span className="text-[10px] font-medium">@{dataUserInfo?.role}</span>
            </div>
          </div>
        </Dropdown>
      </div>
    </Layout.Header>
  );
};

export default Header;
